import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { updateIncomingQuoteLineItem } from "MODULES/IncomingQuotes/actions";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import {
  AS_IS,
  INCOMING_LINE_ITEMS,
  NOT_AWAITING_REPLY
} from "MODULES/IncomingQuotes/constants";
import { removeKeys } from "LIB/removeKey";
import { isEmpty } from "lodash";
import Form from "./Form";

function EditPart({ open, close, onSubmit, selectedLineItem }) {
  const initialValues = {
    other: !isEmpty(selectedLineItem && selectedLineItem.other_tag_type),
    part_id: selectedLineItem && selectedLineItem.part.id,
    ...(selectedLineItem || {})
  };

  const quoteTypes =
    selectedLineItem &&
    [NOT_AWAITING_REPLY, AS_IS].includes(selectedLineItem.quote_type)
      ? INCOMING_LINE_ITEMS.quoteType
      : removeKeys(INCOMING_LINE_ITEMS.quoteType, [NOT_AWAITING_REPLY, AS_IS]);

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Part</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        onSubmit={onSubmit}
        selectedLineItem={selectedLineItem}
        quoteTypes={quoteTypes}
      />
    </Modal>
  );
}

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(updateIncomingQuoteLineItem(data, ownProps.selectedLineItem.id))
}))(EditPart);

EditPart.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedLineItem: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Parts/EditPart.jsx